import * as guardModule from './leave-revoked-writer-rpc-guard.ts';

// Node/tsx loads the canonical TS module as CommonJS; web bundlers use ESM.
// Reflect avoids a static default-import claim against the ESM implementation.
// Both transports expose the same canonical functions and held-name inventory.
const canonicalGuard = Reflect.get(guardModule, 'default') ?? guardModule;
const {
  CLIENT_GUARD_EXEMPT_REVOKED_RPC_NAMES,
  HELD_LEGACY_LEAVE_WRITER_RPC_NAMES,
  HeldLegacyLeaveWriterRpcError,
  assertLegacyLeaveWriterRpcAllowed,
  guardHeldLeaveWriterRpcClient,
  isHeldLegacyLeaveWriterRpcName,
} = canonicalGuard;

export {
  CLIENT_GUARD_EXEMPT_REVOKED_RPC_NAMES,
  HELD_LEGACY_LEAVE_WRITER_RPC_NAMES,
  HeldLegacyLeaveWriterRpcError,
  assertLegacyLeaveWriterRpcAllowed,
  guardHeldLeaveWriterRpcClient,
  isHeldLegacyLeaveWriterRpcName,
};
